import request from '@/utils/request'

export function pageLiveCourse(data) {
  return request({
    url: '/livecourse/liveCourse/page',
    method: 'post',
    data: data
  })
}

export function listLiveCourse(query) {
  return request({
    url: '/livecourse/liveCourse/list',
    method: 'get',
    params: query
  })
}

export function getLiveCourse(data) {
  return request({
    url: '/livecourse/liveCourse/detail',
    method: 'get',
    params: data
  })
}

export function addLiveCourse(data) {
  return request({
    url: '/livecourse/liveCourse/add',
    method: 'post',
    data: data
  })
}

export function updateLiveCourse(data) {
  return request({
    url: '/livecourse/liveCourse/edit',
    method: 'post',
    data: data
  })
}

export function delLiveCourse(data) {
  return request({
    url: '/livecourse/liveCourse/delete',
    method: 'post',
    data: data
  })
}
